<template>
  <div>
    <mds-card size="small" :label="formattedDate" :title="title" :caption="description">
    </mds-card>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'NewsFlashItem',
  components: {
  },
  computed: {
    formattedDate() {
      return moment(this.publishDate).format('MMM DD, YYYY');
    },
  },
  props: {
    itemid: {
      type: String,
      default: '',
      required: true,
    },
    title: {
      type: String,
      default: '',
      required: true,
    },
    publishDate: {
      type: String,
      default: '',
      required: false,
    },
    description: {
      type: String,
      default: '',
      required: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.mds-card {
  border-width: 0px;
  margin-top: $mds-space-1-x;
  width: 100%;
  border-radius: 0;
}

.remove-underline {
  text-decoration: none;
}
.mds-card {
  ::v-deep {
    .mds-card__caption {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
      padding-bottom: $mds-space-quarter-x;
      font-size: $mds-space-2-x !important;
      line-height: 23px!important;
    }
    .mds-card__title {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: $mds-space-2-x !important;
      font-weight: 500 !important;
      padding-bottom: $mds-space-quarter-x;
      line-height: 23px!important;
    }
  }
}
</style>
